module.exports = "<app-spinner [show] =\"loading\"></app-spinner>\r\n"